import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  Button,
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
} from "reactstrap";
import { useNavigate } from "react-router";
import Sidebar from "../../Sidebar";
import Swal from "sweetalert2";
import { useState } from "react";
import { Link, useParams, NavLink } from "react-router-dom";
import React, { Component, Fragment } from "react";
import { BiSave, BiPlus } from "react-icons/bi";
import { IoIosEye } from "react-icons/io";
import { TiCancel } from "react-icons/ti";
import { useCookies } from "react-cookie";
import {displayError,displayErrorToast,parseBoolean, parseBooleanToString, findStateFromGstPortal, mapGstPortalCustomerFields} from '../../helpers';
import { checkForDuplicateCompany, isValidCompanyGstNo, getGstNoValidationMessage } from './CompanyUtils';
import { searchGstin } from '../../services/CustomerMainServices';
import ErrorToast from '../../ErrorToast';
import FloatingControls from '../../components/FloatingControls';
import LoadingOverlay from '../../components/LoadingOverlay';
import { getCompanyDetails, updateCompany, createCompany, testEinvoiceConnection, getCompanyPlantActivitySummary, getCompanyPlantActivityDetails } from '../../services/CompanyServices';
import StatusDropDown from '../../components/StatusDropDown';
import { getIndianStates } from '../../utils/PicklistProvider';
import { getApiBaseUrl, getApiClient } from "../../services/serviceconfig";
import '../../button.css';
import PremiumPageHeader from '../../components/PremiumPageHeader';
import EntityFileUploadField from '../../components/EntityFileUploadField';
import { DatePicker } from 'antd';
import moment from 'moment';
import SettingsIcon from '../../components/SettingsIcon';


var imageUrl = getApiBaseUrl().slice(0, -4);
console.log(imageUrl+"imageUrl");
const axios = require("axios").default;

const COMPANY_IMAGE_FIELDS = [
  { field: 'accounts_in_charge_sign', label: 'accounts signature' },
  { field: 'purchase_in_charge_sign', label: 'purchase signature' },
  { field: 'hr_in_charge_sign', label: 'HR signature' },
  { field: 'sales_in_charge_sign', label: 'sales signature' },
  { field: 'logo', label: 'logo' },
  { field: 'bg_image', label: 'background image' },
  { field: 'seal', label: 'seal' },
];

const INITIAL_COMPANY_FORM_DATA = {
  is_batching_report_needed: 'false',
  is_einvoice_applicable: 'false',
  is_eway_bill_applicable: 'false',
  delivery_challan_document_type: 'delivery_challan',
  einvoice_threshold_limit: 50000000,
  einvoice_environment: 'sandbox',
  status: 'true',
};

const INITIAL_CLEAR_STATE = {
  clear_logo: false,
  clear_seal: false,
  clear_bg_image: false,
  clear_accounts_in_charge_sign: false,
  clear_purchase_in_charge_sign: false,
  clear_hr_in_charge_sign: false,
  clear_sales_in_charge_sign: false,
};

const PLANT_ACTIVITY_COLUMNS = [
  { key: 'customer', label: 'Customer' },
  { key: 'site', label: 'Site' },
  { key: 'quotation', label: 'Quotation' },
  { key: 'sales_order', label: 'Sales Order' },
  { key: 'schedule', label: 'Schedule' },
  { key: 'design_mix', label: 'Design Mix' },
  { key: 'delivery_challan', label: 'Delivery Challan' },
  { key: 'purchase_order', label: 'Purchase Order' },
  { key: 'grn', label: 'GRN' },
];

const EMPTY_PLANT_COUNTS = PLANT_ACTIVITY_COLUMNS.reduce((acc, col) => {
  acc[col.key] = 0;
  return acc;
}, {});

const INITIAL_PLANT_ACTIVITY_FILTERS = {
  fromDate: '',
  toDate: '',
  plantId: '',
};

function toPlantActivityPickerMoment(value) {
  if (!value) return null;
  const parsed = moment(value, 'DD-MM-YYYY', true);
  return parsed.isValid() ? parsed : null;
}

function Company() {
  const [cookies] = useCookies(["myToken"]);
  const navigate = useNavigate();
  const [inProgress, setInProgress] = useState(false);
  const [companyFormData, setCompanyFormData] = useState({ ...INITIAL_COMPANY_FORM_DATA });

  const [plants,setPlants] = useState([])
  const [allPlants, setAllPlants] = useState([])
  const [plantActivityFilters, setPlantActivityFilters] = useState({ ...INITIAL_PLANT_ACTIVITY_FILTERS })
  const [plantActivitySettingsOpen, setPlantActivitySettingsOpen] = useState(false)
  const [plantActivityDraft, setPlantActivityDraft] = useState({ ...INITIAL_PLANT_ACTIVITY_FILTERS })
  const [activityModal, setActivityModal] = useState({
    open: false,
    loading: false,
    title: '',
    columns: [],
    rows: [],
  });
  const [selectedFile, setSelectedFile] = useState({});
  const [isChecked, setIsChecked] = useState({ ...INITIAL_CLEAR_STATE });
  const [error, setError] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(true);
  const { id } = useParams();

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    try{
          if (name === "entity_name") {            //Company name must not be empty,otherwise showing error message  
          
            if (!value.trim()) {
              console.log("Company data is empty");
              setError((values) => ({
                ...values,
                [name]: "Company Name must not be empty...",
              }));
              setIsSubmitting(false);
            } else {
              setError((values) => ({
                ...values,
                [name]: '',
              }));
              setIsSubmitting(true);
            }
          
          } else if (name === "logo" || name === "seal" || name === "bg_image" || name === "accounts_in_charge_sign" || name === "purchase_in_charge_sign" || name === "hr_in_charge_sign" || name === "sales_in_charge_sign") {
            if (event.target.files && event.target.files[0]) {
              setSelectedFile((values) => ({
                ...values,
                [name]: event.target.files[0],
              }));
              setIsChecked((values) => ({
                ...values,
                [`clear_${name}`]: false,
              }));
            }
            return;
          } else if (name === 'einvoice_environment') {
            setCompanyFormData((values) => ({ ...values, [name]: value }));
            if ((companyFormData.gst_no || '').trim()) {
              validateGstNo(companyFormData.gst_no, value);
            }
            return;
          } else if (name === 'delivery_challan_document_type') {
            setCompanyFormData((values) => ({
              ...values,
              [name]: value,
              ...(value === 'delivery_challan_einvoice' || value === 'delivery_challan_eway_bill_einvoice'
                ? { is_einvoice_applicable: 'true' }
                : {}),
              ...(value === 'delivery_challan_eway_bill_einvoice'
                ? { is_eway_bill_applicable: 'true' }
                : {}),
            }));
            return;
          }

          setCompanyFormData((values) => ({ ...values, [name]: event.target.value }));
        }

  catch (e)
  {
   displayErrorToast(e);
  }
}

const handleClear = (event) => {
  const name = event.target.name;
  const value = event.target.checked;
  setIsChecked((values) => ({ ...values, [name]: value }));
  const fieldName = name.replace('clear_', '');
  if (value) {
    setSelectedFile((values) => {
      const next = { ...values };
      delete next[fieldName];
      return next;
    });
    const input = document.getElementById(`${fieldName}_upload`);
    if (input) {
      input.value = '';
    }
  }
};

const validateImageClearConflicts = () => {
  for (const { field, label } of COMPANY_IMAGE_FIELDS) {
    const clearKey = `clear_${field}`;
    if (selectedFile[field] && isChecked[clearKey]) {
      Swal.fire(`Please either upload a new ${label} or check Clear, not both.`, '', 'info');
      return false;
    }
  }
  return true;
};

const validateGstNo = (value, environment = companyFormData.einvoice_environment) => {
  try {
    const trimmed = (value || '').trim().toUpperCase();
    if (!trimmed) {
      setError((values) => ({ ...values, gst_no: '' }));
      setIsSubmitting(true);
      setCompanyFormData((values) => ({ ...values, gst_no: '' }));
      return;
    }
    if (isValidCompanyGstNo(trimmed, environment)) {
      setError((values) => ({ ...values, gst_no: '' }));
      setIsSubmitting(true);
      setCompanyFormData((values) => ({ ...values, gst_no: trimmed }));
      if (trimmed.length === 15) {
        searchGstin(cookies, trimmed)
          .then((data) => {
            if (data.success && data.result) {
              const mapped = mapGstPortalCustomerFields(data.result);
              const st = findStateFromGstPortal(mapped.stcd, getIndianStates());
              setCompanyFormData((prev) => ({
                ...prev,
                entity_name: mapped.name || prev.entity_name,
                address_1: mapped.address_1 || prev.address_1,
                address_2: mapped.address_2 || prev.address_2,
                address_3: mapped.address_3 || prev.address_3,
                pincode: mapped.pincode || prev.pincode,
                state: st?.value || prev.state,
                gst_no: trimmed,
                pan_no: trimmed.substring(2, 12) || prev.pan_no,
              }));
            } else if (data?.message) {
              Swal.fire(data.message, `GST NO: ${trimmed}`, 'info');
            }
          })
          .catch((error) => {
            displayError(error, 'GST lookup failed');
          });
      }
    } else {
      setError((values) => ({ ...values, gst_no: getGstNoValidationMessage(environment) }));
      setIsSubmitting(false);
      setCompanyFormData((values) => ({ ...values, gst_no: trimmed }));
    }
  } catch (e) {
    displayErrorToast(e);
  }
};

const validate_items = (name,value,regular_expr,error_message) =>
{
   try{
     
        if(value.trim())            //If regex is statisfied condition is valid it accept ,otherwise it is Invalid                      
        {
            if(!regular_expr.test(value.trim()))
            {
                setError(values => ({...values, [name]: error_message}))
                setIsSubmitting(false); 
            }
            else
            {
                setError(values => ({...values, [name]: ''}))
                setIsSubmitting(true);
            }
        } else if (name === 'pan_no') {
          setError(values => ({...values, [name]: 'must not be empty...'}))
          setIsSubmitting(true);
        } else {
          setError(values => ({...values, [name]: ''}))
          setIsSubmitting(true);
        }
        setCompanyFormData(values => ({...values, [name]: value}))
    }
 
   catch (e)
      {
       displayErrorToast(e);
      }
 }  

  const handleSubmit = (event) => {
    event.preventDefault();
   var companyId = event.currentTarget.dataset.id;
    try{
        if (companyId && !validateImageClearConflicts()) {
          return;
        }
        checkForDuplicateCompany(event.target.entity_name.value,cookies,companyId)
      .then(isNameExists => {
          
        if (isNameExists) {
          setError(values => ({...values, [event.target.entity_name.name]: 'Company name already exists.'}));
        } else {

          if (Object.values(error).every((x) => !x) && isSubmitting) {        //If the fields are correct details it is valid choosing yes or no option,otherwise it is invalid
            if (companyId) {
              handleUpdate();
            } else {
              handleCreate();
            }
          } else {
            Swal.fire("Please check * marked fields are filled and details given are valid...","","info" );
          }
        }
    }); 
  } catch (e) {
      displayErrorToast(e);
  } 
        
 } 
 
 const constructFormData = () => {

  const EMPTY_STRING = '';
  const dataArray = new FormData();
        if (selectedFile.logo) {
          dataArray.append("logo", selectedFile.logo);
        }
        if (selectedFile.bg_image) {
          dataArray.append("bg_image", selectedFile.bg_image);
        }
        if (selectedFile.seal) {
          dataArray.append("seal", selectedFile.seal);
        }
        if (selectedFile.accounts_in_charge_sign) {
          dataArray.append("accounts_in_charge_sign", selectedFile.accounts_in_charge_sign);
        }
        if (selectedFile.purchase_in_charge_sign) {
          dataArray.append("purchase_in_charge_sign", selectedFile.purchase_in_charge_sign);
        }
        if (selectedFile.hr_in_charge_sign) {
          dataArray.append("hr_in_charge_sign", selectedFile.hr_in_charge_sign);
        }
        if (selectedFile.sales_in_charge_sign) {
          dataArray.append("sales_in_charge_sign", selectedFile.sales_in_charge_sign);
        }
        dataArray.append("id",companyFormData.id); 
          dataArray.append("alias", companyFormData.alias);
          dataArray.append("entity_name", companyFormData.entity_name.toUpperCase());
          dataArray.append("address_1",companyFormData.address_1 || EMPTY_STRING);
          dataArray.append("address_2",companyFormData.address_2 || EMPTY_STRING);
          dataArray.append("address_3",companyFormData.address_3  || EMPTY_STRING);
          dataArray.append("pincode",companyFormData.pincode  || EMPTY_STRING);
          dataArray.append("state",companyFormData.state  || EMPTY_STRING);
          dataArray.append("phone_number",companyFormData.phone_number  || EMPTY_STRING);
          dataArray.append("mobile_number",companyFormData.mobile_number  || EMPTY_STRING);
          dataArray.append("email_id",companyFormData.email_id  || EMPTY_STRING);
          dataArray.append("web",companyFormData.web  || EMPTY_STRING);
          dataArray.append("commencement_dt",companyFormData.commencement_dt);
          dataArray.append("pan_no",companyFormData.pan_no.toUpperCase());
          dataArray.append("cin_no",companyFormData.cin_no || EMPTY_STRING);
          dataArray.append("gst_no", (companyFormData.gst_no || '').toUpperCase());
          
           dataArray.append("cst_no",companyFormData.cst_no || EMPTY_STRING);
          dataArray.append("lut_no",companyFormData.lut_no || EMPTY_STRING);
          dataArray.append("tan_no",companyFormData.tan_no || EMPTY_STRING);
          dataArray.append("pf_no",companyFormData.pf_no || EMPTY_STRING);
          dataArray.append("esi_no",companyFormData.esi_no || EMPTY_STRING);
          dataArray.append("opening_dt",companyFormData.opening_dt);
          dataArray.append("closing_dt",companyFormData.closing_dt);
          dataArray.append("is_batching_report_needed",companyFormData.is_batching_report_needed);
          dataArray.append("is_einvoice_applicable", companyFormData.is_einvoice_applicable || 'false');
          dataArray.append("is_eway_bill_applicable", companyFormData.is_eway_bill_applicable || 'false');
          dataArray.append("delivery_challan_document_type", companyFormData.delivery_challan_document_type || 'delivery_challan');
          dataArray.append("einvoice_valid_from", companyFormData.einvoice_valid_from || '');
          dataArray.append("einvoice_threshold_limit", companyFormData.einvoice_threshold_limit || 50000000);
          dataArray.append("einvoice_environment", companyFormData.einvoice_environment || 'sandbox');
          dataArray.append("einvoice_gsp_client_id", companyFormData.einvoice_gsp_client_id || '');
          dataArray.append("einvoice_gsp_client_secret", companyFormData.einvoice_gsp_client_secret || '');
          dataArray.append("einvoice_api_username", companyFormData.einvoice_api_username || '');
          dataArray.append("einvoice_api_password", companyFormData.einvoice_api_password || '');
          dataArray.append("accounts_in_charge", companyFormData.accounts_in_charge || EMPTY_STRING);
          dataArray.append("accounts_in_charge_designation", companyFormData.accounts_in_charge_designation || EMPTY_STRING);
          dataArray.append("purchase_in_charge", companyFormData.purchase_in_charge || EMPTY_STRING);
          dataArray.append("purchase_in_charge_designation", companyFormData.purchase_in_charge_designation || EMPTY_STRING);
          dataArray.append("hr_in_charge", companyFormData.hr_in_charge || EMPTY_STRING);
          dataArray.append("hr_in_charge_designation", companyFormData.hr_in_charge_designation || EMPTY_STRING);
          dataArray.append("sales_in_charge", companyFormData.sales_in_charge || EMPTY_STRING);
          dataArray.append("sales_in_charge_designation", companyFormData.sales_in_charge_designation || EMPTY_STRING);
          if (companyFormData.id) {
            dataArray.append("clear_logo", isChecked.clear_logo || false);
            dataArray.append("clear_seal", isChecked.clear_seal || false);
            dataArray.append("clear_bg_image", isChecked.clear_bg_image || false);
            dataArray.append("clear_accounts_in_charge_sign", isChecked.clear_accounts_in_charge_sign || false);
            dataArray.append("clear_purchase_in_charge_sign", isChecked.clear_purchase_in_charge_sign || false);
            dataArray.append("clear_hr_in_charge_sign", isChecked.clear_hr_in_charge_sign || false);
            dataArray.append("clear_sales_in_charge_sign", isChecked.clear_sales_in_charge_sign || false);
          }
          dataArray.append("status",parseBoolean(companyFormData.status)); 
          dataArray.append("user_remarks",companyFormData.user_remarks || EMPTY_STRING);
    return dataArray;
 }

  const handleCreate = () => {

    Swal.fire({title: 'Do you want to save?',  
      showCancelButton: true,  
      confirmButtonText: `Yes`,  
      cancelButtonText: `No`,
      }).then((result) => {  
        if (result.isConfirmed) 
        { 
          const dataArray = constructFormData();
          console.log(JSON.stringify(dataArray)+"dataArray")
          createCompany(cookies, dataArray)
          .then(function (response) {
            Swal.fire('Saved!', '', 'success') 
            Reload();
            //Cancel();
          }).catch(function (error) {
            console.log(error);
            displayError(error.response.data,'Save Failed');
          });
          setInProgress(false);
        }
        else if (result.isDismissed) 
        {    
          Swal.fire('Not saved', '', 'info')  
          
        }
      });
  }

  const handleUpdate = () => {
    Swal.fire({
      title: "Do you want to Update?",
      showCancelButton: true,
      confirmButtonText: `Yes`,
      cancelButtonText: `No`,
       }).then((result) => {
        if (result.isConfirmed) {
           const dataArray = constructFormData();
         
       updateCompany(cookies,dataArray,id)
          .then(response => {
            Swal.fire("Updated!", "", "success");
            Reload();
        })
        .catch((error) => {
            console.log(error.response.data);
            displayError(error.response.data,"Update Failed");
    });
        // Swal.fire("Updated!", "", "success");
        // Reload();
      } else if (result.isDismissed) {
        Swal.fire("Not Updated", "", "info");
      }
    });
  }

  const Reload = () => {
    navigate("/CompanyTable");
  };

  const view = () => {
    navigate("/CompanyTable");
  };

  const handleNew = () => {
    navigate("/Company");
  };

  const onEditPlant = (plantId) => {
    navigate(`/PlantEdit/${plantId}/`, { state: { returnTo: `/CompanyEdit/${id}/` } });
  };

  const loadPlantActivitySummary = (companyId, filters = plantActivityFilters) => {
    if (!companyId) {
      return Promise.resolve(null);
    }
    return getCompanyPlantActivitySummary(cookies, companyId, filters)
      .then((summary) => {
        if (summary?.plants) {
          setPlants(summary.plants.map((plant) => ({ ...EMPTY_PLANT_COUNTS, ...plant })));
        }
        if (summary?.from_date !== undefined || summary?.to_date !== undefined || summary?.plant_id !== undefined) {
          setPlantActivityFilters({
            fromDate: summary?.from_date || '',
            toDate: summary?.to_date || '',
            plantId: summary?.plant_id ? String(summary.plant_id) : '',
          });
        }
        return summary;
      });
  };

  const openPlantActivitySettings = () => {
    setPlantActivityDraft({ ...plantActivityFilters });
    setPlantActivitySettingsOpen(true);
  };

  const closePlantActivitySettings = () => {
    setPlantActivitySettingsOpen(false);
  };

  const applyPlantActivitySettings = () => {
    const nextFilters = { ...plantActivityDraft };
    if (nextFilters.fromDate && nextFilters.toDate) {
      const fromM = moment(nextFilters.fromDate, 'DD-MM-YYYY', true);
      const toM = moment(nextFilters.toDate, 'DD-MM-YYYY', true);
      if (fromM.isValid() && toM.isValid() && fromM.isAfter(toM)) {
        Swal.fire('From date must be on or before To date.', '', 'warning');
        return;
      }
    }
    setPlantActivityFilters(nextFilters);
    setPlantActivitySettingsOpen(false);
    setInProgress(true);
    loadPlantActivitySummary(id, nextFilters)
      .catch((error) => {
        displayError(error.response?.data || error, 'Loading Failed');
      })
      .finally(() => {
        setInProgress(false);
      });
  };

  const clearPlantActivitySettings = () => {
    const cleared = { ...INITIAL_PLANT_ACTIVITY_FILTERS };
    setPlantActivityDraft(cleared);
    setPlantActivityFilters(cleared);
    setPlantActivitySettingsOpen(false);
    setInProgress(true);
    loadPlantActivitySummary(id, cleared)
      .catch((error) => {
        displayError(error.response?.data || error, 'Loading Failed');
      })
      .finally(() => {
        setInProgress(false);
      });
  };

  const getPlantActivityFilterSummary = () => {
    const parts = [];
    if (plantActivityFilters.fromDate || plantActivityFilters.toDate) {
      parts.push(
        plantActivityFilters.fromDate && plantActivityFilters.toDate
          ? `${plantActivityFilters.fromDate} to ${plantActivityFilters.toDate}`
          : plantActivityFilters.fromDate
            ? `From ${plantActivityFilters.fromDate}`
            : `Up to ${plantActivityFilters.toDate}`,
      );
    }
    if (plantActivityFilters.plantId) {
      const selectedPlant = allPlants.find((plant) => String(plant.id) === String(plantActivityFilters.plantId));
      parts.push(selectedPlant ? `Plant: ${selectedPlant.alias || selectedPlant.name}` : 'Plant filtered');
    }
    return parts.join(' | ');
  };

  const openPlantActivityDetails = (plant, activity) => {
    const count = Number(plant[activity.key] || 0);
    if (!id || count <= 0) {
      return;
    }
    setActivityModal({
      open: true,
      loading: true,
      title: `${activity.label} — ${plant.alias || plant.name}`,
      columns: [],
      rows: [],
    });
    getCompanyPlantActivityDetails(cookies, id, plant.id, activity.key, plantActivityFilters)
      .then((response) => {
        setActivityModal({
          open: true,
          loading: false,
          title: `${activity.label} — ${plant.alias || plant.name}`,
          columns: response.columns || [],
          rows: response.rows || [],
        });
      })
      .catch((error) => {
        setActivityModal({
          open: false,
          loading: false,
          title: '',
          columns: [],
          rows: [],
        });
        displayError(error.response?.data || error, 'Loading Failed');
      });
  };

  const closePlantActivityDetails = () => {
    setActivityModal({
      open: false,
      loading: false,
      title: '',
      columns: [],
      rows: [],
    });
  };

  const resetCompanyForm = () => {
    setCompanyFormData({ ...INITIAL_COMPANY_FORM_DATA });
    setSelectedFile({});
    setIsChecked({ ...INITIAL_CLEAR_STATE });
    setPlants([]);
    setAllPlants([]);
    setPlantActivityFilters({ ...INITIAL_PLANT_ACTIVITY_FILTERS });
    setPlantActivityDraft({ ...INITIAL_PLANT_ACTIVITY_FILTERS });
    setPlantActivitySettingsOpen(false);
    setError({});
    setIsSubmitting(true);
    setInProgress(false);
    COMPANY_IMAGE_FIELDS.forEach(({ field }) => {
      const input = document.getElementById(`${field}_upload`);
      if (input) {
        input.value = '';
      }
    });
  };

  const loadCompanyDetails = (companyId) => {
    setInProgress(true);
    getCompanyDetails(cookies, companyId)
      .then((companyObject) => {
        setCompanyFormData({
          ...companyObject,
          status: String(companyObject.status),
          is_einvoice_applicable: String(companyObject.is_einvoice_applicable ?? false),
          is_eway_bill_applicable: String(companyObject.is_eway_bill_applicable ?? false),
          delivery_challan_document_type: companyObject.delivery_challan_document_type || 'delivery_challan',
          einvoice_threshold_limit: companyObject.einvoice_threshold_limit ?? 50000000,
          einvoice_environment: companyObject.einvoice_environment || 'sandbox',
          einvoice_gsp_client_id: companyObject.einvoice_gsp_client_id || '',
          einvoice_gsp_client_secret: companyObject.einvoice_gsp_client_secret || '',
          einvoice_api_username: companyObject.einvoice_api_username || '',
          einvoice_api_password: companyObject.einvoice_api_password || '',
        });
        const companyPlants = companyObject.plants || [];
        setAllPlants(companyPlants);
        setPlants(companyPlants.map((plant) => ({ ...plant, ...EMPTY_PLANT_COUNTS })));
        setSelectedFile({});
        setIsChecked({ ...INITIAL_CLEAR_STATE });
        setError({});
        setIsSubmitting(true);
        setInProgress(false);
        return loadPlantActivitySummary(companyId, plantActivityFilters);
      })
      .catch((error) => {
        console.log(error);
        setInProgress(false);
        displayError(error.response?.data || error, 'Loading Failed');
      });
  };
 
  const Cancel = () => {
    if (id) {
      loadCompanyDetails(id);
      return;
    }
    resetCompanyForm();
  }

  const isLiveEinvoice = (companyFormData.einvoice_environment || 'sandbox').toLowerCase() === 'production';

  const handleTestEinvoiceConnection = () => {
    if (!companyFormData.id) {
      Swal.fire('Save the company first, then test the GST API connection.', '', 'info');
      return;
    }
    testEinvoiceConnection(cookies, companyFormData.id)
      .then((response) => {
        Swal.fire(response.message || 'GST API connection successful.', '', 'success');
      })
      .catch((error) => {
        displayError(error.response?.data || { message: 'GST API connection failed.' }, 'Connection Failed');
      });
  };

  React.useEffect(() => {
    if (id) {
      loadCompanyDetails(id);
    } else {
      resetCompanyForm();
    }
  }, [id]);
  
  const func1 = (arg1, arg2) => {

  };

  const renderFileUploadField = (fieldName, label) => (
    <EntityFileUploadField
      fileKey={fieldName}
      existingValue={companyFormData[fieldName]}
      clearFieldName={`clear_${fieldName}`}
      label={label}
      selectedFile={selectedFile}
      isChecked={isChecked}
      imageUrl={imageUrl}
      onChange={handleChange}
      onClear={handleClear}
    />
  );

  return (
    <>
        <Sidebar pageWrapId={"page-wrap"} outerContainerId={"outer-container"}/>
        <ErrorToast/>
        <LoadingOverlay inProgress={inProgress}/>
        <div id="page-wrap">
          <form onSubmit={handleSubmit} data-id={companyFormData.id} encType="multipart/form-data">
            <PremiumPageHeader
              module="ADMIN"
              title="Company Registration & Setup"
              subtitle="Register company profile, statutory details, and linked plant associations."
              modeLabel={id ? 'EDIT MODE' : 'CREATE MODE'}
            />

            <FloatingControls
              tableLink="/CompanyTable"
              formLink={id ? "/Company" : undefined}
              addNewLabel="New Company"
              onCancel={Cancel}
              enableCancel={true}
            />
            <div className="container"> 
              <Row> 
              <Col xl={6} lg={12} md={12}>   
             
                      <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 bg-blue form-control-panel">  
                      <h5 className='col-sm-11'><b>Company Details</b></h5><br/><br/>  
                              <label htmlFor="entity_name" className="form-group col-sm-4 text-right" style={{ whiteSpace: 'nowrap' }}>Company Name </label>
                              <input type="text" id="entity_name" name="entity_name" onChange={handleChange} value={companyFormData.entity_name || ""} className="form-control col-sm-7 mandatory-form-control"  placeholder="Please fill the NAME field *" maxLength="100" required /><br/>
                              {error.entity_name && (<><strong className="form-group col-sm-12 text-center text-danger" >{error.entity_name}</strong><br/></>)}
                              
                              <label htmlFor="alias"className="form-group col-sm-4 text-right  "> Alias</label>
                              <input type="text" id="alias" name="alias" onChange={handleChange} value={companyFormData.alias || ""}  className="form-control col-sm-7 "  placeholder="Please fill the Alias Field *" /><br/>
                              
                              <label htmlFor="address_1"className="form-group col-sm-4 text-right  "> Address</label>
                              <input type="text" id="address_1" name="address_1" onChange={handleChange} value={companyFormData.address_1 || ""} className="form-control col-sm-7  rounded " /><br/>
                              
                              <label htmlFor="address_2" className="form-group col-sm-4 text-right  "></label>
                              <input type="text" id="address_2"  name="address_2" onChange={handleChange} value={companyFormData.address_2 || ""} className="form-control col-sm-7 rounded "  /><br/>
                              
                              <label htmlFor="address_3"  className="form-group col-sm-4 text-right  "></label>
                              <input type="text" id="address_3" name="address_3" onChange={handleChange} value={companyFormData.address_3 || ""} className="form-control col-sm-7 rounded "  /><br/>
                              
                              <label htmlFor="pincode"className="form-group col-sm-4 text-right  ">Pin Code</label>
                              <input name="pincode" id="pincode" onChange={ (event) => validate_items(event.target.name,event.target.value,/^[1-9][0-9]{5}$/,"invalid Pincode")} maxLength = "6" value={companyFormData.pincode || ""} className="form-control col-sm-7" type = "text" /><br/>
                              {error.pincode && (<><strong className="form-group col-sm-12 text-center text-danger" >{error.pincode}</strong><br/></>)}
                              
                              <label htmlFor="state"className="form-group col-sm-4 text-right  ">State</label>
                              <select id="state" name="state" className="browser-default custom-select form-control col-sm-7 mandatory-form-control" required onChange={handleChange} value={companyFormData.state || ""}>
                              <option value="">Select State</option>
                                    {
                                      getIndianStates()
                                      .map(indian_state => <option key={indian_state.value} value={indian_state.value}>{indian_state.name}</option>
                                      )
                                    }
                                  </select><br/><br/>
                                            
                              <label htmlFor="phone_number"className="form-group col-sm-4 text-right  ">Phone No</label>
                              <input  type="tel" id="phone_number" name="phone_number"onChange={handleChange} value={companyFormData.phone_number || ""} className="form-control col-sm-7" /><br/>
                              
                              <label htmlFor="mobile_number"className="form-group col-sm-4 text-right  ">Mobile No</label>
                              <input type="text" id="mobile_number" name="mobile_number" onChange={handleChange} value={companyFormData.mobile_number || ""} pattern="[0-9]{10}"  maxLength="10" className="form-control col-sm-7 " /><br/>

                              <label htmlFor="web"className="form-group col-sm-4 text-right">Web</label>
                              <input type="text" id="web" name="web" onChange={handleChange} value={companyFormData.web || ""}className="form-control col-sm-7" /><br/>
                              
                              <label htmlFor="email_id"className="form-group col-sm-4 text-right  ">Email id</label>
                              <input type="email" id="email_id" name="email_id"  onChange={ (event) => validate_items(event.target.name,event.target.value,/^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/,"invalid Emailid")} value={companyFormData.email_id|| ""} className="form-control col-sm-7 " /><br/>
                              {error.email_id && (<><strong className="form-group col-sm-12 text-center text-danger" >{error.email_id}</strong><br/></>)}
                             
                              <label htmlFor="is_batching_report_needed"className="form-group col-sm-4 text-right ">Batching Report</label>
                          <select id="is_batching_report_needed" required name="is_batching_report_needed" onChange={handleChange} value={companyFormData.is_batching_report_needed || 'false'}className="browser-default custom-select col-sm-7 mandatory-form-control">
                              <option value=''>Please select</option>
                              <option value='true'>Yes</option>
                              <option value='false'>No</option>
                         </select> <br></br><br></br>

                          <h5 className='col-sm-11'><b>Accounting Dates</b></h5><br/> 

                            <label htmlFor="commencement_dt"className="form-group col-sm-4 text-right">Commencement date </label>
                            <input type="date" id="commencement_dt" name="commencement_dt" onChange={handleChange} value={companyFormData.commencement_dt|| ""} className="form-control col-sm-7 rounded mandatory-form-control" required maxLength="50"/><br/>
                            
                            <label htmlFor="opening_dt"className="form-group col-sm-4 text-right  "> Opening date </label>
                            <input type="date" id="opening_dt" name="opening_dt" onChange={handleChange} value={companyFormData.opening_dt || ""}className="form-control col-sm-7 rounded mandatory-form-control" required  maxLength="50"/><br/>
                            
                            <label htmlFor="closing_dt"className="form-group col-sm-4 text-right  ">Closing date </label>
                            <input type="date"  id="closing_dt"  name="closing_dt" onChange={handleChange} value={companyFormData.closing_dt || ""}className="form-control col-sm-7 rounded mandatory-form-control" required maxLength="50"/><br/>
                            <br></br>
                            
                      </div>

                      <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 bg-blue form-control-panel">
                        <h5 className='col-sm-11'><b>Management and Signature Repository</b></h5><br/>

                        <label htmlFor="accounts_in_charge" className="form-group col-sm-4 text-right">Accounts In-Charge</label>
                        <input type="text" id="accounts_in_charge" name="accounts_in_charge" onChange={handleChange} value={companyFormData.accounts_in_charge || ""} className="form-control col-sm-7" /><br/>

                        <label htmlFor="accounts_in_charge_designation" className="form-group col-sm-4 text-right">Designation</label>
                        <input type="text" id="accounts_in_charge_designation" name="accounts_in_charge_designation" onChange={handleChange} value={companyFormData.accounts_in_charge_designation || ""} className="form-control col-sm-7" /><br/>

                        {renderFileUploadField('accounts_in_charge_sign', 'Signature')}

                        <label htmlFor="purchase_in_charge" className="form-group col-sm-4 text-right">Purchase In-Charge</label>
                        <input type="text" id="purchase_in_charge" name="purchase_in_charge" onChange={handleChange} value={companyFormData.purchase_in_charge || ""} className="form-control col-sm-7" /><br/>

                        <label htmlFor="purchase_in_charge_designation" className="form-group col-sm-4 text-right">Designation</label>
                        <input type="text" id="purchase_in_charge_designation" name="purchase_in_charge_designation" onChange={handleChange} value={companyFormData.purchase_in_charge_designation || ""} className="form-control col-sm-7" /><br/>

                        {renderFileUploadField('purchase_in_charge_sign', 'Signature')}

                        <label htmlFor="hr_in_charge" className="form-group col-sm-4 text-right">HR In-Charge</label>
                        <input type="text" id="hr_in_charge" name="hr_in_charge" onChange={handleChange} value={companyFormData.hr_in_charge || ""} className="form-control col-sm-7" /><br/>

                        <label htmlFor="hr_in_charge_designation" className="form-group col-sm-4 text-right">Designation</label>
                        <input type="text" id="hr_in_charge_designation" name="hr_in_charge_designation" onChange={handleChange} value={companyFormData.hr_in_charge_designation || ""} className="form-control col-sm-7" /><br/>

                        {renderFileUploadField('hr_in_charge_sign', 'Signature')}

                        <label htmlFor="sales_in_charge" className="form-group col-sm-4 text-right">Sales In-Charge</label>
                        <input type="text" id="sales_in_charge" name="sales_in_charge" onChange={handleChange} value={companyFormData.sales_in_charge || ""} className="form-control col-sm-7" /><br/>

                        <label htmlFor="sales_in_charge_designation" className="form-group col-sm-4 text-right">Designation</label>
                        <input type="text" id="sales_in_charge_designation" name="sales_in_charge_designation" onChange={handleChange} value={companyFormData.sales_in_charge_designation || ""} className="form-control col-sm-7" /><br/>

                        {renderFileUploadField('sales_in_charge_sign', 'Signature')}
                      </div>
                  </Col>
                  <Col xl={6} lg={12} md={12}>
                  <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 bg-blue form-control-panel " >   
                      {/* <div className="form-row table-bordered border-primary border p-2 mb-3" style={{backgroundColor:"rgba(68,158,228,0.9)",borderRadius:"10px",fontWeight:"bold"}}> */}
                      <h5 className='col-sm-11'><b>Company Statuatory</b></h5><br/>
                          <label htmlFor="pan_no"className="form-group col-sm-4 text-right  ">PAN No </label>
                          <input type="text" id="pan_no" required name="pan_no" onChange={ (event) => validate_items(event.target.name,event.target.value,/^[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}$/,"invalid PANNo")}  value={companyFormData.pan_no || ""}className="form-control col-sm-7 mandatory-form-control"  placeholder="Please fill the PAN field *"  /><br/>
                          {error.pan_no && (<><strong className="form-group col-sm-12 text-center text-danger" >{error.pan_no}</strong><br/></>)}

                          <label htmlFor="cin_no"className="form-group col-sm-4 text-right  ">CIN No</label>
                          <input type="text" id="cin_no" name="cin_no"  onChange={handleChange}
                          // onChange={ (event) => validate_items(event.target.name,event.target.value,/^[1-9][0-9]{5}$/,"invalid CIN No")} 
                          value={companyFormData.cin_no || ""}className="form-control col-sm-7 "  /><br/>
                          {error.cin_no && (<><strong className="form-group col-sm-12 text-center text-danger" >{error.cin_no}</strong><br/></>)}


                          <label htmlFor="gst_no"className="form-group col-sm-4 text-right  ">GST No </label>
                          <input type="text" id="gst_no" name="gst_no" onChange={(event) => validateGstNo(event.target.value)} value={companyFormData.gst_no || ""} className="form-control col-sm-7" placeholder="Optional — auto-fills from GST portal when entered" maxLength="15" /><br/>
                          {error.gst_no && (<><strong className="form-group col-sm-12 text-center text-danger" >{error.gst_no}</strong><br/></>)}
                          
                          <label htmlFor="lut_no"className="form-group col-sm-4 text-right  ">LUT No</label>
                          <input type="number" id="lut_no" name="lut_no" onChange={handleChange}
                          // onChange={ (event) => validate_items(event.target.name,event.target.value,/^[1-9][0-9]{5}$/,"invalid LUTNo")} 
                          value={companyFormData.lut_no|| ""}className="form-control col-sm-7 " /><br/>
                          {error.lut_no && (<><strong className="form-group col-sm-12 text-center text-danger" >{error.lut_no}</strong><br/></>)}
                              
                          <label htmlFor="cst_no"className="form-group col-sm-4 text-right  ">CST No</label>
                          <input type="text" id="cst_no" name="cst_no"  onChange={handleChange}
                          // onChange={ (event) => validate_items(event.target.name,event.target.value,/^[1-9][0-9]{5}$/,"invalid CSTNo")}
                           value={companyFormData.cst_no || ""}className="form-control col-sm-7 "  /><br/>
                          {error.cst_no && (<><strong className="form-group col-sm-12 text-center text-danger" >{error.cst_no}</strong><br/></>)}
                          
                          <label htmlFor="tan_no"className="form-group col-sm-4 text-right  ">TAN No</label>
                          <input type="text" id="tan_no" name="tan_no" onChange={handleChange} 
                          // onChange={ (event) => validate_items(event.target.name,event.target.value,/^[1-9][0-9]{5}$/,"invalid TANNo")} 
                          value={companyFormData.tan_no || ""}className="form-control col-sm-7 "  /><br/>
                          {error.tan_no && (<><strong className="form-group col-sm-12 text-center text-danger" >{error.tan_no}</strong><br/></>)}

                          <label htmlFor="pf_no"className="form-group col-sm-4 text-right  ">PF No</label>
                          <input type="text" id="pf_no" name="pf_no"  onChange={handleChange} 
                          // onChange={ (event) => validate_items(event.target.name,event.target.value,/^[1-9][0-9]{5}$/,"invalid PFNo")}  
                          value={companyFormData.pf_no || ""} className="form-control col-sm-7 "  /><br/>
                          {error.pf_no && (<><strong className="form-group col-sm-12 text-center text-danger" >{error.pf_no}</strong><br/></>)}

                          <label htmlFor="esi_no"  className="form-group col-sm-4 text-right  ">ESI No</label>
                          <input type="text" id="esi_no" name="esi_no" onChange={handleChange} 
                          // onChange={ (event) => validate_items(event.target.name,event.target.value,/^[1-9][0-9]{5}$/,"invalid ESINo")} 
                          value={companyFormData.esi_no || ""} className="form-control col-sm-7 " /><br/>
                          {error.esi_no && (<><strong className="form-group col-sm-12 text-center text-danger" >{error.esi_no}</strong><br/></>)}

                           </div>

                           <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 bg-blue form-control-panel" >
                      <h5 className='col-sm-11'><b>Files Uploading Centre</b></h5><br/>

                           {renderFileUploadField('logo', 'Logo')}
                           {renderFileUploadField('bg_image', 'Background Image')}
                           {renderFileUploadField('seal', 'Seal')}

</div>

                
                      <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 bg-blue form-control-panel" >
                      {/* <div className="form-row table-bordered border-primary border p-2 mb-3" style={{backgroundColor:"rgba(68,158,228,0.9)",borderRadius:"10px",fontWeight:"bold"}}> */}
                      <h5 className='col-sm-11'><b>Company Status</b></h5><br/>

                      <StatusDropDown status={companyFormData.status} onChange={handleChange}/>

                          <label htmlFor="user_remarks" className="form-group col-sm-4 text-right">Remarks</label>
                          <input type="text" id="user_remarks" name="user_remarks"onChange={handleChange} value={companyFormData.user_remarks || ""} maxLength="1000" placeholder="IF ANY"  className="form-control  col-sm-7" /><br/><br/>
                          
                      </div>

                      <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 bg-blue form-control-panel">
                     <h5 className='col-sm-11'><b>E-Invoice / E-Way Bill (GST)</b></h5><br/>

                     <label htmlFor="delivery_challan_document_type" className="form-group col-sm-4 text-right">Delivery Challan Document</label>
                     <select
                       id="delivery_challan_document_type"
                       name="delivery_challan_document_type"
                       onChange={handleChange}
                       value={companyFormData.delivery_challan_document_type || 'delivery_challan'}
                       className="browser-default custom-select col-sm-7 mandatory-form-control"
                       required
                     >
                       <option value="delivery_challan">Delivery Challan</option>
                       <option value="delivery_challan_tax_invoice">Delivery Challan Cum Tax Invoice</option>
                       <option value="delivery_challan_einvoice">Delivery Challan Cum E-Invoice</option>
                       <option value="delivery_challan_eway_bill_einvoice">Delivery Challan + E-Way Bill + E-Invoice</option>
                     </select><br/>

                     <label htmlFor="is_einvoice_applicable" className="form-group col-sm-4 text-right">E-Invoice Applicable</label>
                     <select id="is_einvoice_applicable" name="is_einvoice_applicable" onChange={handleChange} value={companyFormData.is_einvoice_applicable || 'false'} className="browser-default custom-select col-sm-7 mandatory-form-control" required>
                       <option value="false">No</option>
                       <option value="true">Yes</option>
                     </select><br/>

                     <label htmlFor="is_eway_bill_applicable" className="form-group col-sm-4 text-right">E-Way Bill Applicable</label>
                     <select id="is_eway_bill_applicable" name="is_eway_bill_applicable" onChange={handleChange} value={companyFormData.is_eway_bill_applicable || 'false'} className="browser-default custom-select col-sm-7 mandatory-form-control" required>
                       <option value="false">No</option>
                       <option value="true">Yes</option>
                     </select><br/>

                     <label htmlFor="einvoice_valid_from" className="form-group col-sm-4 text-right">Valid From</label>
                     <input type="date" id="einvoice_valid_from" name="einvoice_valid_from" onChange={handleChange} value={companyFormData.einvoice_valid_from || ""} className="form-control col-sm-7 rounded" /><br/>

                     <label htmlFor="einvoice_threshold_limit" className="form-group col-sm-4 text-right">Threshold Limit</label>
                     <input type="number" id="einvoice_threshold_limit" name="einvoice_threshold_limit" min="0" step="1" onChange={handleChange} value={companyFormData.einvoice_threshold_limit ?? 50000000} className="form-control col-sm-7" placeholder="Default: 50000000 (5 Crore)" /><br/>

                     <h5 className='col-sm-11'><b>GST Portal API (Adaequare GSP)</b></h5>
                     <p className="col-sm-11 text-muted small mb-2">
                       GST No auto-fill always uses this software&apos;s authorization.
                       For e-Invoice (IRN): Sandbox needs your test GSP Client ID/Secret; Live uses application GSP automatically.
                     </p><br/>

                     <label htmlFor="einvoice_environment" className="form-group col-sm-4 text-right">Environment</label>
                     <select id="einvoice_environment" name="einvoice_environment" onChange={handleChange} value={companyFormData.einvoice_environment || 'sandbox'} className="browser-default custom-select col-sm-7 mandatory-form-control" required>
                       <option value="sandbox">Sandbox (Test)</option>
                       <option value="production">Live (Production)</option>
                     </select><br/>

                     {isLiveEinvoice ? (
                       <p className="col-sm-11 text-muted small mb-2">
                         Live mode: GSP Client ID and Secret are taken from this application automatically.
                         Enter API Username and Password only.
                       </p>
                     ) : (
                       <>
                         <label htmlFor="einvoice_gsp_client_id" className="form-group col-sm-4 text-right">GSP Client ID</label>
                         <input type="text" id="einvoice_gsp_client_id" name="einvoice_gsp_client_id" onChange={handleChange} value={companyFormData.einvoice_gsp_client_id || ''} className="form-control col-sm-7" placeholder="Required for Sandbox test" /><br/>

                         <label htmlFor="einvoice_gsp_client_secret" className="form-group col-sm-4 text-right">GSP Client Secret</label>
                         <input type="password" id="einvoice_gsp_client_secret" name="einvoice_gsp_client_secret" onChange={handleChange} value={companyFormData.einvoice_gsp_client_secret || ''} className="form-control col-sm-7" placeholder="Required for Sandbox test" /><br/>
                       </>
                     )}

                     <label htmlFor="einvoice_api_username" className="form-group col-sm-4 text-right">API Username</label>
                     <input type="text" id="einvoice_api_username" name="einvoice_api_username" onChange={handleChange} value={companyFormData.einvoice_api_username || ''} className="form-control col-sm-7" placeholder="NIC e-Invoice portal username" /><br/>

                     <label htmlFor="einvoice_api_password" className="form-group col-sm-4 text-right">API Password</label>
                     <input type="password" id="einvoice_api_password" name="einvoice_api_password" onChange={handleChange} value={companyFormData.einvoice_api_password || ''} className="form-control col-sm-7" placeholder="NIC e-Invoice portal password" /><br/>

                     {companyFormData.id && (
                       <>
                         <label className="form-group col-sm-4 text-right"></label>
                         <Button type="button" className="btn btn-info col-sm-7" style={{ fontWeight: 'bold' }} onClick={handleTestEinvoiceConnection}>
                           Test Sandbox / Live Connection
                         </Button>
                         <br />
                       </>
                     )}
                   </div>
                  </Col>
               </Row>             
          </div>
            <div className="footer company-form-footer text-center">
              <div className="company-form-footer-actions">
                <Button type="submit" className="company-form-action-btn">
                  <BiSave size={18} />
                  {id ? 'Update' : 'Save'}
                </Button>
                <Button type="button" className="company-form-action-btn" onClick={Cancel}>
                  <TiCancel size={18} />
                  Cancel
                </Button>
                <Button type="button" className="company-form-action-btn" onClick={view}>
                  <IoIosEye size={18} />
                  View
                </Button>
                {id && (
                  <Button type="button" className="company-form-action-btn" onClick={handleNew}>
                    <BiPlus size={18} />
                    New
                  </Button>
                )}
              </div>
            </div>

            {
              id && 
              <div className="container">
              <Row>
              <Col xl={12} lg={24} md={24}>
           
                <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 bg-blue form-control-panel company-plant-activity-panel">
                    <div className="company-plant-activity-header">
                      <div className="company-plant-activity-header-text">
                        <b>No.of Plants Associated with this Company : {plants.length}</b>
                        {getPlantActivityFilterSummary() ? (
                          <span className="company-plant-activity-filter-summary">
                            {getPlantActivityFilterSummary()}
                          </span>
                        ) : null}
                      </div>
                      <SettingsIcon onClickHandler={openPlantActivitySettings} variant="inline" />
                    </div>
                    <div className="company-plant-activity-table-wrap">
                    <table className="company-plant-activity-table" width={"100%"} align={"center"}>
                      <thead>
                      <tr>
                        <td>Plant (Plant Alias)</td>
                        {PLANT_ACTIVITY_COLUMNS.map((col) => (
                          <td key={col.key}>{col.label}</td>
                        ))}
                        <td>Action</td>
                      </tr>
                      </thead>
                      <tbody>
                        {plants.map(cmp => (
                          <tr key={cmp.id}>
                            <td className="company-plant-activity-name" title={cmp.alias || cmp.name}>
                              {cmp.alias || cmp.name}
                            </td>
                            {PLANT_ACTIVITY_COLUMNS.map((col) => {
                              const count = Number(cmp[col.key] || 0);
                              return (
                                <td key={col.key} className="company-plant-activity-count">
                                  {count > 0 ? (
                                    <button
                                      type="button"
                                      className="company-plant-activity-count-btn"
                                      onClick={() => openPlantActivityDetails(cmp, col)}
                                    >
                                      {count}
                                    </button>
                                  ) : (
                                    <span>0</span>
                                  )}
                                </td>
                              );
                            })}
                            <td style={{ textAlign: 'center' }}>
                              <Button
                                type="button"
                                size="sm"
                                color="primary"
                                style={{ fontWeight: 'bold', minWidth: '60px' }}
                                onClick={() => onEditPlant(cmp.id)}
                              >
                                Edit
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    </div>
                </div>
              </Col>
              </Row>
            </div>
            }
            
          </form>
        </div>
        {plantActivitySettingsOpen && (
          <>
            <div className="company-plant-activity-overlay" onClick={closePlantActivitySettings} />
            <div className="company-plant-activity-modal company-plant-activity-settings-modal" role="dialog" aria-modal="true">
              <div className="company-plant-activity-modal-header">
                <h2>Plant Activity Settings</h2>
                <button
                  type="button"
                  className="company-plant-activity-modal-close"
                  aria-label="Close"
                  onClick={closePlantActivitySettings}
                >
                  ×
                </button>
              </div>
              <div className="company-plant-activity-modal-body company-plant-activity-settings-body">
                <Row className="g-3">
                  <Col md={6}>
                    <label className="company-plant-activity-settings-label">From Date</label>
                    <DatePicker
                      className="company-plant-activity-settings-date"
                      format="DD-MM-YYYY"
                      value={toPlantActivityPickerMoment(plantActivityDraft.fromDate)}
                      onChange={(value) => {
                        setPlantActivityDraft((current) => ({
                          ...current,
                          fromDate: value ? value.format('DD-MM-YYYY') : '',
                        }));
                      }}
                      allowClear
                      placeholder="All dates"
                      getPopupContainer={() => document.body}
                      dropdownClassName="sales-settings-date-popup"
                    />
                  </Col>
                  <Col md={6}>
                    <label className="company-plant-activity-settings-label">To Date</label>
                    <DatePicker
                      className="company-plant-activity-settings-date"
                      format="DD-MM-YYYY"
                      value={toPlantActivityPickerMoment(plantActivityDraft.toDate)}
                      onChange={(value) => {
                        setPlantActivityDraft((current) => ({
                          ...current,
                          toDate: value ? value.format('DD-MM-YYYY') : '',
                        }));
                      }}
                      allowClear
                      placeholder="All dates"
                      getPopupContainer={() => document.body}
                      dropdownClassName="sales-settings-date-popup"
                    />
                  </Col>
                  <Col md={12}>
                    <label className="company-plant-activity-settings-label">Plant</label>
                    <Input
                      type="select"
                      value={plantActivityDraft.plantId}
                      onChange={(event) => {
                        setPlantActivityDraft((current) => ({
                          ...current,
                          plantId: event.target.value,
                        }));
                      }}
                    >
                      <option value="">All Plants</option>
                      {allPlants.map((plant) => (
                        <option key={plant.id} value={plant.id}>
                          {plant.alias || plant.name}
                        </option>
                      ))}
                    </Input>
                  </Col>
                </Row>
                <div className="company-plant-activity-settings-actions">
                  <Button type="button" color="secondary" outline onClick={clearPlantActivitySettings}>
                    Clear
                  </Button>
                  <Button type="button" color="primary" onClick={applyPlantActivitySettings}>
                    Apply
                  </Button>
                </div>
              </div>
            </div>
          </>
        )}
        {activityModal.open && (
          <>
            <div className="company-plant-activity-overlay" onClick={closePlantActivityDetails} />
            <div className="company-plant-activity-modal" role="dialog" aria-modal="true">
              <div className="company-plant-activity-modal-header">
                <h2>{activityModal.title}</h2>
                <button
                  type="button"
                  className="company-plant-activity-modal-close"
                  aria-label="Close"
                  onClick={closePlantActivityDetails}
                >
                  ×
                </button>
              </div>
              <div className="company-plant-activity-modal-body">
                {activityModal.loading ? (
                  <p>Loading details...</p>
                ) : !activityModal.rows.length ? (
                  <p>No records found.</p>
                ) : (
                  <table className="company-plant-activity-detail-table">
                    <thead>
                      <tr>
                        {activityModal.columns.map((column) => (
                          <th key={column}>{column}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {activityModal.rows.map((row) => (
                        <tr key={row.id}>
                          {(row.cells || []).map((value, index) => (
                            <td key={`${row.id}-${index}`}>{value ?? ''}</td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </>
        )}
    </>
  );
}

export default Company;
